import React from 'react';

class BulletOnline extends React.Component {
	render () {
		// Par défaut on affiche offline
		let onlineCSSClass = 'streamOffline';

		// Si le stream est online
		if (this.props.isOnline) {
			onlineCSSClass = 'streamOnline';
		}

		// Si est pendant le chargement
		if (this.props.isLoading) {
			onlineCSSClass += ' graybullet';
		}

		const bulletCSSClass = 'streamBullet blocRond ' + onlineCSSClass;

		return (
			<div className="col txtmiddle w80p col-mobile">
				<div className={bulletCSSClass}></div>
			</div>
		);
	}
}

export default BulletOnline;